import { DateTime } from "luxon";
import uuid from "uuid/v1";
import {
  priceTriggerType,
  OutcomePriceType,
} from "../../../api/constants/priceTriggerEnums";
import { mapGetters, mapMutations, mapActions } from "vuex";

import { getTrackingOrdersByMinutes, isUserPhoneVerified } from "../../../api/services/userService";
import { getDbRef, readProductData } from "../../../api/helpers/rtdbHelper";
import { normalizeQueryParams } from "../../../api/helpers/uiHelper";

export default {
  computed: {
    ...mapGetters([
      "tsMenuAvailable",
      "activePopup",
      "redeemptionRuleApplied",
      "getSurchareHolidayName",
      "user",
      "selectedCompany",
      "storeSelectionAtCheckoutMode",
      "deliveryAddress",
      "priceTriggerOutcomes",
      "cartValue",
      "cartItems",
      "totaltax",
      "getIsDelivery",
      "getShowDeliveryFee",
      "discount",
      "getTotalPrice",
      "deliveryFee",
      "mobileStyles",
      "desktopStyles",
      "getFirstValidRedemptionRule",
      "storeMenu",
      "getProductInCategoryInfo",
      "reedemptionPoints",
      "getSurchargeAmount",
      "getSurchargeBankAmount",
      "getSurchargeHolidayAmount",
      "costlyCartItems",
      "currentStoreDoc",
      "addressOutOfService",
      "getSelectedTriggerCheckOutPage",
      "getTriggerCheckOutPage",
      "getDeliveryAddressMessage",
      "getTotalPoints",
      "getProductOutcomeInfo",
      "getDeliveryIsLoading",
      "storeSupportsLoyaltyPoints",
      "buttonStyles",
      "currencySign",
      "redemptionDiscount",
      "getloadedMenu",
      "getStoreTimeSettingsClosed",
      "getSelectedMenuType",
      "viewConfig",
      "getTotalPriceWithoutTips",
      "showSharedCart",
      "getSharedCart",
      "getPeople",
      "getSharedCartProps",
      "getTotalPriceWithoutTipsSurcharge",
      "getTipCustomAmount",
      "getTipPercent",
      "multipleMenuEnabled",
      "storeClosed",
      "enableStamps",
      "collectableStamps",
      "loyaltyUnit",
      "getSharedCartSingleOrder",
      "payLaterNotifications",
      "paylaterSettings",
      "sharedCartLength",
      "menuUnAvailable",
      "totalGst",
      "user",
      "selectedCompany",
      "storeSupportEarningLoyaltyPoints",
    ]),

    showRedemptionButton() {
      return (
        this.getFirstValidRedemptionRule &&
        (this.redemptionDiscount == 0 ||
          (this.redemptionDiscount > 0 &&
            !this.getFirstValidRedemptionRule.ProductVariant)) &&
        this.cartItems.length > 0
      );
    },
    RedemptionButtonText() {
      if (
        this.getFirstValidRedemptionRule.ProductVariant ||
        !this.redeemptionRuleApplied
      ) {
        return `${this.$t("message.redeemPoints")}: ${
          this.getFirstValidRedemptionRule.Name
        }`;
      } else {
        return this.$t("message.RemoveLoyalty");
      }
    },
    isIndonesian() {
      let locale = this.selectedCompany
        ? this.selectedCompany.CurrencyLocaleName
        : null;

      return typeof locale === "string"
        ? locale.toLowerCase() === "id-id"
        : false;
    },
    taxLabel() {
      return this.isIndonesian
        ? this.$t("message.tax")
        : this.$t("message.gst");
    },
    totalLabel() {
      return this.isIndonesian
        ? this.$t("message.totalIncTax")
        : this.$t("message.totalIncGST");
    },
    menuCopy() {
      return JSON.parse(JSON.stringify(this.storeMenu));
    },
    getPoints() {
      if (this.enableStamps) return this.collectableStamps;
      else if (this.storeSupportsLoyaltyPoints || this.storeSupportEarningLoyaltyPoints)
        return this.getTotalPoints;
      else return null;
    },
    wholeOrderDiscount() {
      var res = this.priceTriggerOutcomes.find(
        (pt) => pt.type == priceTriggerType.wholeOrderDiscountPriceTriggers
      );
      return res;
    },
    wholeOrderDiscountMessage() {
      var res = this.wholeOrderDiscount;
      if (res) {
        switch (res.OutcomePriceType) {
          case OutcomePriceType.OutcomePriceType_PercentageDiscount:
            if (!res.DiscountPercentageValue) return "";
            return (
              this.$t("message.thisOrderWillBeDiscounted") +
              " " +
              res.DiscountPercentageValue * 100 +
              "%"
            );
          case OutcomePriceType.OutcomePriceType_FlatDiscount:
            if (!res.DiscountFlatValue) return "";
            return (
              this.$t("message.thisOrderWillBeDiscounted") +
              " $" +
              res.DiscountFlatValue
            );
          default:
            return "";
        }
      }
      return "";
    },
    cartLength() {
      let sum = 0;
      this.cartItems
        .filter((p) => !p.disable)
        .forEach((element) => {
          sum += parseInt(element.quantity);
        });
      return sum;
    },
    totalPrice() {
      return this.getTotalPriceWithoutTips;
    },
    totalPriceWithoutTipsSurcharge() {
      return this.getTotalPriceWithoutTipsSurcharge;
    },
    subtotalPrice() {
      return this.cartValue - (this.totalGst || 0);
    },
    showDelivery() {
      return this.getShowDeliveryFee && this.getIsDelivery;
    },
    exceedMinPurchase() {
      return this.totalPrice >= this.minPurchase;
    },
    refreshTime() {
      return DateTime.local().set({ hour: 10, minute: 0, second: 0 }).toUTC();
    },
    now() {
      return DateTime.toUTC();
    },
    showNewUi() {
      return this.viewConfig.IsNewUi;
    },
    orderDisbaled() {
      if (
        this.selectedCompany.Delivery ||
        this.selectedCompany.EatIn ||
        this.selectedCompany.PickUp
      ) {
        const isSingleShareCartOrderAvailable =
          !this.getSharedCartSingleOrder &&
          this.getPeople &&
          this.getPeople.length;
        if (!isSingleShareCartOrderAvailable) {
          if (this.cartItems.filter((p) => !p.disable).length == 0) return true;
          if (this.minPurchase > 0) {
            if (!this.exceedMinPurchase) return true;
          }
        }
        const checkOutAllowed = !isSingleShareCartOrderAvailable
          ? this.exceedMinPurchase ||
            this.cartItems.filter((p) => !p.disable).length > 0
          : true;
        return (
          !checkOutAllowed ||
          (!isSingleShareCartOrderAvailable &&
            this.costlyCartItems.length == 0) ||
          this.storeClosed === true ||
          !this.dpTimeIsSet ||
          !this.store.IsInOperation ||
          this.proccessing ||
          this.getDeliveryIsLoading
        );
      } else {
        return true;
      }
    },
    totalTipValue() {
      const totalPriceWithoutSurcharge = this.totalPriceWithoutTipsSurcharge;
      const tipPercent = this.getTipPercent;
      const customTipAmount = this.getTipCustomAmount;
      const totalValue = customTipAmount
        ? customTipAmount
        : (Number(tipPercent) / 100) * totalPriceWithoutSurcharge;
      return totalValue;
    },
    tipSelected() {
      const savedTipPercent = this.getTipPercent;
      const tipSelected = this.tips.find(
        (x) => x.percentValue == savedTipPercent
      );
      if (tipSelected) {
        return tipSelected.id || 0;
      }

      // default tip
      return 0;
    },
    wastageReport() {
      const guestCount = Number(normalizeQueryParams(this.$route.query)['guestcount']);
      return (
        this.payLaterNotifications.WastageAlert.Enabled &&
        this.sharedCartLength >= guestCount * this.paylaterSettings.WastageLimit
      );
    },
  },
  methods: {
    ...mapMutations([
      "REMOVE_GIFTCART_ITEM",
      "REMOVE_CART_ITEM",
      "Add_ProductItem",
      "setShowDeliveryFee",
      "setShowOverlay",
      "toggleRedeemptionRule",
      "addTip",
      "clearTips",
    ]),
    ...mapActions([
      "insertWarninglog",
      "applyPriceTriggers",
      "fixRedemptionQuantity",
      "updateShoppingCartItems",
      "addTip",
      "addCustomTip",
      "setItems",
      "setSharedCartProps",
    ]),
    showWastageAlert() {
      this.wastageAlertEnabled = true;
    },
    async navigateToCheckout() {
      if (this.$refs.myBottomSheet) {
        this.$refs.myBottomSheet.close();
      }
      const enableMobileAuthentication =
        this.viewConfig.EnableMobileAuthentication !== false;
      if (
        !this.user &&
        !this.isBranded() &&
        this.viewConfig.LogIn === true &&
        enableMobileAuthentication
      ) {
        this.showMobileOtpModal = true;
        return;
      }

      if (
        this.showSharedCart &&
        this.getSharedCart &&
        this.getPeople.length > 0
      ) {
        const items = [];
        if (this.getSharedCartSingleOrder) {
          const { user } = this.getSharedCartProps;
          const products = this.getSharedCart[user].products;
          products.map((product) => {
            items.push(product);
          });
        } else {
          this.getPeople.forEach((user) => {
            const products = this.getSharedCart[user].products;
            products.map((product) => {
              items.push(product);
            });
          });
        }
        this.setItems(items);
      }
      // change from rolld to all branded stores isRolldStore->isBranded
      if (this.isBranded()) {
        if (!this.user) {
          this.setShowOverlay({ value: true, redirectedFromCheckout: true });
          return;
        }

        // if field is not explicitly set to false, display mobile authentication
        const enableMobileAuthentication =
          this.viewConfig.EnableMobileAuthentication !== false;
        const isMobileVerified = await isUserPhoneVerified();

        if (!isMobileVerified && enableMobileAuthentication) {
          this.setShowOverlay({ value: true, redirectedFromCheckout: true });
          return;
        }
      }

      let orderFound = false;
      const remainingTime = {
        minutes: 0,
        seconds: 0,
      };
      const blockTime = this.selectedCompany.ViewComponentConfigs && this.selectedCompany.ViewComponentConfigs.BlockTimeEnabled
        ? this.selectedCompany.ViewComponentConfigs.BlockTimeInterval
        : 0;
      if (this.$route.query && this.$route.query.table && blockTime) {
        const tableNumber = this.$route.query.table;
        const minutesPast = blockTime * 60;
        const minutesAgo = new Date(Date.now() - minutesPast * 1000);
        const userID = this.user && this.user.id ? this.user.id : '';
        const orderSnap = await getTrackingOrdersByMinutes(userID, this.selectedCompany.ID, minutesAgo);
        const orders = await orderSnap.get();
        if(!orders.empty) {
          const currentTime = new Date();
          orders.forEach(order => {
            const orderData = order.data();
            if (orderData.CreatedOn && orderData.OrderType === 8) {
              const orderTable = orderData.Tables && orderData.Tables.length ? orderData.Tables[0].Name : '';
              if (orderTable && orderTable === tableNumber) {
                const createdOn = orderData.CreatedOn.toDate();
                const diffInMilliseconds = currentTime - createdOn;
                const diffInSeconds = Math.floor(diffInMilliseconds / 1000);

                if (diffInSeconds < minutesPast) {
                  orderFound = true;
                  const remainingTimeInSeconds = minutesPast - diffInSeconds;
                  remainingTime.minutes = Math.floor(remainingTimeInSeconds / 60);
                  remainingTime.seconds = remainingTimeInSeconds % 60;
                }
              }
            }
          })
        }
      }
      if (orderFound) {
        this.blockTimeAlertEnabled = true;
        this.remainingTime = remainingTime;
        return
      }
      if (this.storeSelectionAtCheckoutMode) {
        var routename = this.isMobile() ? "checkout" : "mainpage";
        this.$router.push({
          name: routename,
          query: this.isMobile()
            ? {}
            : {
                selectMode: true,
              },
        });
      } else {
        var routeName = this.IsSaveOrder ? "saveOrderMobile" : "checkout";
        this.$router.push({
          name: routeName,
          params: {
            storeid: this.$route.params.storeid,
            storename: this.$route.params.storename,
          },
        });
      }
    },
    redirectToCheckOut() {
      if (this.storeSelectionAtCheckoutMode) {
        const routename = this.isMobile() ? "checkout" : "mainpage";
        this.$router.push({
          name: routename,
          query: this.isMobile()
            ? {}
            : {
                selectMode: true,
              },
        });
      } else {
        const routeName = this.IsSaveOrder ? "saveOrderMobile" : "checkout";
        this.$router.push({
          name: routeName,
          params: {
            storeid: this.$route.params.storeid,
            storename: this.$route.params.storename,
          },
        });
      }
    },
    validateCardAndRules() {
      if (this.store.ChargeToRoom) {
        this.destroyOldCard();
        this.timerId = setInterval(this.destroyOldCard, 5000);
      }
      this.computeRules(this.orderType);
    },
    //desktop
    focusCart() {
      if (this.$refs.cartWrapper) this.$refs.cartWrapper.click();
    },
    applyCoupon(code) {
      this.$refs.couponComponent.applyCoupon(code);
    },
    SelecteDPTime(selecteDpTime) {
      if (!selecteDpTime) this.dpTimeIsSet = false;
      else this.dpTimeIsSet = true;
    },
    selectTriggerCheckOutPageEvent(value) {
      this.setSelectedTriggerCheckOutPage(value);
      this.$forceUpdate();
    },
    //mobile
    closeQrCodeScanner() {
      this.$refs.couponComponent.closeQrCodeScanner();
    },
    goOrder() {
      this.$router.push({
        name: "store",
        params: {
          storeid: this.$route.params.storeid,
          torename: this.$route.params.storename,
        },
      });
    },
    continueOrder() {
      this.$router.push({
        name: "store",
        params: {
          storeid: this.$route.params.storeid,
          storename: this.$route.params.storename,
        },
      });
    },
    clearAllOrders() {
      if (this.cartItems) {
        this.cartItems.forEach((cartitem) => {
          this.REMOVE_CART_ITEM({
            item: cartitem,
            sharedcart: this.showSharedCart,
            user: this.getSharedCartProps.user,
            table: this.getSharedCartProps.table,
            storeId: this.currentStoreDoc.ID,
          });
          this.toggleRedeemptionRule(false);
          this.applyPriceTriggers();
        });
      }
    },
    destroyOldCard() {
      //if now after 10 am
      if (this.now.isAfter(this.refreshTime) && this.cartItems) {
        this.cartItems.forEach((element) => {
          let createdTime = DateTime.fromFormat(element.created).toUTC();
          if (createdTime.isBefore(this.refreshTime)) {
            this.REMOVE_CART_ITEM({ item: element });
            this.applyPriceTriggers();
          }
        });
      }
    },
    giftDestroyOldCard() {
      //if now after 10 am
      if (this.now.isAfter(this.refreshTime) && this.giftCartItems) {
        this.giftCartItems.forEach((element) => {
          let createdTime = DateTime.fromFormat(element.created).toUTC();
          if (createdTime.isBefore(this.refreshTime)) {
            this.REMOVE_GIFTCART_ITEM({ item: element });
          }
        });
      }
    },
    computeRules() {
      //min purchase
      if (this.store) {
        if (this.store.OrderTypeConstraintRules) {
          this.minPurchase = this.store.OrderTypeConstraintRules[this.orderType]
            ? this.store.OrderTypeConstraintRules[this.orderType]
                .MinimumTotalPrice
            : 0;
        }
      }
    },
    openPrivacyPolicyModal() {
      this.showPrivacyModal = true;
    },
    closePrivacyPolicyModal() {
      this.$refs.privacyModal.hideModal();
      this.showPrivacyModal = false;
    },
    giftGoOrder() {
      this.$router.push({
        name: "giftstorev2",
        params: { storeid: this.store.ID, storename: this.store.Name },
      });
    },
    giftContinueOrder() {
      this.$router.push({
        name: "giftstorev2",
        params: {
          storeid: this.$route.params.storeid,
          storename: this.$route.params.storename,
        },
      });
    },
    giftComputeRules() {
      //delivery fee
      if (this.store.FreightFeeRules) {
        for (let i = 0; i < this.store.FreightFeeRules.length; i++) {
          const rule = this.store.FreightFeeRules[i];
          if (
            this.giftTotalPrice > rule.PriceRangeMinimum &&
            this.giftTotalPrice < rule.PriceRangeMaximum
          ) {
            this.deliveryFee = rule.FreightFeeAmount;
            break;
          }
        }
      }

      //min purchase
      if (this.store) {
        if (this.store.OrderTypeConstraintRules) {
          this.minPurchase = this.store.OrderTypeConstraintRules[this.orderType]
            ? this.store.OrderTypeConstraintRules[this.orderType]
                .MinimumTotalPrice
            : 0;
        }
      }
    },

    closeModal() {
      this.$refs.redemptionModal.hideModal();
      this.showRedemption = false;
    },
    selectRollIntoModiefiers(modifiers) {
      if (this.selectedReedemption) {
        this.confirmReedemption(this.selectedReedemption.product, modifiers);
        this.selectedReedemption = null;
        this.$refs.redemptionModal.hideModal();
        this.showRedemption = false;
        return;
      }
    },
    addReedemption() {
      var product =
        this.menuCopy.Products[this.getFirstValidRedemptionRule.ProductVariant];
      if (
        product &&
        product.ModifierGroups &&
        product.ModifierGroups.length > 0
      ) {
        this.selectedReedemption = {
          product: product,
          modifiers: this.menuCopy.ModifierGroups,
          productId: this.getFirstValidRedemptionRule.ProductVariant.toString(),
        };
        this.showRedemption = true;
      } else {
        this.confirmReedemption(product);
      }
    },
    confirmReedemption(product, modifiers = []) {
      this.toggleRedeemptionRule();
      if (product) {
        var productInfo = this.getProductInCategoryInfo(
          this.getFirstValidRedemptionRule.ProductVariant
        );
        var newPrice = productInfo.Price;
        this.Add_ProductItem({
          item: {
            id: this.getFirstValidRedemptionRule.ProductVariant,
            uniqueId: uuid(),
            itemNote: "",
            code: product.ProductCode,
            name: product.Name,
            description: product.ShortDescription,
            photoUrl: product.PhotoUrl,
            tax: product.TaxRate,
            price: newPrice,
            reedemptionRule: this.getFirstValidRedemptionRule,
            RewardPoint: product.RewardPoint,
            categoryId:
              this.productInfo && this.productInfo.categoryId
                ? this.productInfo.categoryId
                : null,
            categoryName:
              this.productInfo && this.productInfo.categoryName
                ? this.productInfo.categoryName
                : null,
            IsMaxQuantityLevelEnabled: product.IsMaxQuantityLevelEnabled,
          },
          quantity: 1,
          PreparationTime: product.PreparationTime,
          ProductCategoryIDs: product.ProductCategoryIDs,
          ProductTagIDs: product.ProductTagIDs,
          modifiers: modifiers,
        });
      }
      this.applyPriceTriggers();

      if (
        !(
          this.getFirstValidRedemptionRule.ProductVariant ||
          !this.redeemptionRuleApplied
        )
      ) {
        if (this.showNewUi && this.viewConfig.EnableConfetti) {
          this.$confetti.start();
          setTimeout(() => {
            this.$confetti.stop();
          }, 2500);
        }
      }
    },
    // get the value of tip based on percentage and total cart value
    tipsValue(percentageValue) {
      const tipValue =
        ((this.totalPriceWithoutTipsSurcharge || 0) * percentageValue) / 100;
      return Number(tipValue.toFixed(2) || 0);
    },
    // set first tip as initial tip when modal tips pops up
    setInitialTip() {
      if (!this.totalTipValue) {
        const defaultTip = this.tips[0];
        this.selectTip(defaultTip.id, defaultTip.percentValue);
      }
      this.openTips();
    },
    selectTip(id, percent) {
      this.clearTips();
      this.addTip(percent);
    },
    // set first tip as initial tip when modal tips pops up
    clearTip() {
      this.clearTips();
    },

    selectCustomTip(tip) {
      this.clearTips();
      this.addCustomTip(tip);
    },

    // open and close tips modals
    openTips() {
      this.$refs.myBottomSheet.open();
    },
    closeTips() {
      this.$refs.myBottomSheet.close();
    },

    // open and close coupon modals
    openCoupon() {
      this.$refs.couponBottomSheet.open();
    },
    closeCoupon() {
      this.$refs.couponBottomSheet.close();
    },
    onMobileOtpClose() {
      this.showMobileOtpModal = false;
      this.$refs.mobileOtpModal.hideModal(true);
    },
    restoreListener(storeID, table) {
      const dbRef = getDbRef(storeID, table);
      dbRef.on("child_changed", async () => {
        const newData = await readProductData(table, storeID);
        this.setSharedCartProps(newData);
      });

      dbRef.on("child_added", async (data) => {
        if (this.getPeople && this.getPeople.includes(data.key)) {
          const newData = await readProductData(table, storeID);
          this.setSharedCartProps(newData);
        }
      });

      dbRef.on("child_removed", async () => {
        const newData = await readProductData(table, storeID);
        const updatedCart = newData ? newData : {};
        this.setSharedCartProps(updatedCart);
      });
    },
    hideBlockModel() {
      this.blockTimeAlertEnabled = false;
    }
  },
};
